import { useEffect, useState } from "react";
import { TerritoryLoadingScreen } from "./territory-loading-screen";

/** Owns waiting/recovery timing only; authentication remains with the caller. */
export function WorkspaceLoadingShell({
  label,
  onRetry,
  onSignOut,
}: {
  label: string;
  onRetry?: () => void;
  onSignOut?: () => void;
}) {
  const [attempt, setAttempt] = useState(0);
  const [delayed, setDelayed] = useState(false);
  const [retryOffered, setRetryOffered] = useState(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: a new operation or retry restarts the delay even though its value is not used inside the timer.
  useEffect(() => {
    // A new pending operation or retry gets its own full waiting interval.
    setDelayed(false);
    const timer = window.setTimeout(() => {
      setDelayed(true);
      setRetryOffered(true);
    }, 8_000);
    return () => window.clearTimeout(timer);
  }, [attempt, label]);

  function retry() {
    setDelayed(false);
    setAttempt((current) => current + 1);
    onRetry?.();
  }

  return (
    <TerritoryLoadingScreen
      label={label}
      delayed={delayed}
      retryVisible={retryOffered && Boolean(onRetry)}
      onRetry={retry}
      onSignOut={onSignOut}
    />
  );
}
